module.exports = __webpack_public_path__ + "static/media/jessica-roca.aa13987f.jpg";